export default __webpack_public_path__ + "static/media/A94.99be91ad.png";